import I18n from './i18n';
var globalI18n = new I18n();
export var init = globalI18n.init;
export var __ = globalI18n.t;
export default globalI18n;